import { ModuleTag } from '../../../../../../entities/module/private-template-module-tag/ui/module-tag';
import css from './group-tag-list.module.scss';
import { workshopModuleTagApi } from '../../../../../../entities/module/workshop-module-tag';

interface GroupTagListProps {
    selectedTags: number[],
    onRemoveChoicedItem: (value: string) => void,
}

export const WorkshopModuleTagList = ({
	selectedTags,
	onRemoveChoicedItem,
}: GroupTagListProps) => {
	const { data: tagsData } = workshopModuleTagApi.useGetWorkshopTagsQuery({
		limit: 127,
		page: 1,
	});

	const selectedTagsSet = new Set(selectedTags);

	if (!tagsData?.moduleTags) {
		return null;
	}

	return (
		<div className={css.tags_block}>
			{
				tagsData.moduleTags
					.filter(tag => selectedTagsSet.has(tag.id))
					.map(tag => {
						const { id } = tag;

						return (
							<ModuleTag
								tag={tag}
								onDelete={() => onRemoveChoicedItem(String(id))}
								key={id}
							/>
						);
					})
			}
		</div>
	);
};
